<template>
    <div class="formBuilder">
        <Accord
                :title="item.title"
                :link="getAnchorLink(item)"
                :linkName="item.anchor"
                v-bind:key="item.title"
                v-for="item in formData">
            <h4 v-if="item.description != null">{{ item.description }}</h4>
            <div :class="item.grid">
				<template v-for="input in item.forms">

					<template v-if="input.type == 'section'">
						<Section :input="input" :formValue="formValue"></Section>
					</template>
					<template v-else-if="input.type == 'sectionarray'">
						<SectionArray :input="input" :formValue="formValue"></SectionArray>
					</template>
					<template v-else-if="input.type == 'sectionpicker'">
						<SectionPicker :input="input" :formValue="formValue"></SectionPicker>
					</template>
					<template v-else-if="input.type == 'sectiontable'">
						<SectionTable :input="input" :formValue="formValue"></SectionTable>
					</template>
					<template v-else-if="input.type == 'materialreviewtable'">
						<MaterialReviewTable :input="input" :formValue="formValue"></MaterialReviewTable>
					</template>
					<template v-else-if="input.type == 'aggregationtable'">
						<AggregationTable :input="input" :formValue="formValue"></AggregationTable>
					</template>
					<template v-else>
						<InputField :input="input" :formValue="formValue"></InputField>
					</template>

				</template>
            </div>
        </Accord>
    </div>
</template>

<script>
    import Accord from "../Components/Accord.vue"
    import InputField from "./FormBuilder/InputField.vue"
    import Section from "./FormBuilder/Section.vue"
    import SectionArray from "./FormBuilder/SectionArray.vue"
    import SectionPicker from "./FormBuilder/SectionPicker.vue"
    import SectionTable from "./FormBuilder/SectionTable.vue"
	import MaterialReviewTable from "./FormBuilder/MaterialReviewTable.vue"
    import AggregationTable from "./FormBuilder/AggregationTable.vue"

    export default {
        components: {
            Accord,
            InputField,
            SectionArray,
            Section,
            SectionPicker,
            SectionTable,
			MaterialReviewTable,
            AggregationTable
        },
        name: "FormBuilder",        
        props: {
            formData: {
                type: Array,
                required: true
            },
            formValue: {
                type: Object,
                required: false
            }
        },
        mounted () {
           
        },      
        methods: {
            getAnchorLink(item) {
                if(!item.anchor) return null;

                // Specific for StudyEditor links. Should not be here...
                const level = parseInt(item.anchor.split(".")[0]) - 1;
                const section = parseInt(item.anchor.split(".")[1]) - 1;

                return "/study/" + this.$route.params.id + "/" + level + "/" + section;
            }
        }
    }
</script>